import { createFileRoute } from "@tanstack/react-router";
import { DocPage } from "@/features/docpage/DocPage";

export const Route = createFileRoute("/_app/docs/$doc")({ component: Page });

function Page() {
  const { doc } = Route.useParams();
  return <DocPage id={doc} />;
}
